exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-2a1f8b09]{margin-top:35px}.handle[data-v-2a1f8b09]{float:left}.close[data-v-2a1f8b09],.handle[data-v-2a1f8b09]{padding-top:8px;padding-bottom:8px}.close[data-v-2a1f8b09]{float:right}input[data-v-2a1f8b09]{display:inline-block;width:50%}.text[data-v-2a1f8b09]{margin:20px}", ""]);

// exports
